<user-ingot-base [user]="user" [link]="link">
  {{ user.job_title }}
</user-ingot-base>
